import { LeftOutlined } from '@ant-design/icons';
import { Button, Col, Row, Skeleton, Space, Typography } from 'antd';
import { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useGetMigrationYClientsQuery } from '@app/api/Migration';
import { DATA_MIGRATION_PATH, MOBILE } from '@app/constants';
import { useContentWidth, useUserPrint } from '@app/hooks';
import { useErrorHandler } from '@app/shared/hooks';
import { handleTimestamp } from '@app/utils';

import { StatusTag } from '@pages/DataMigration/components/StatusTag';

import type { FC } from 'react';

const { Text } = Typography;

export const DataMigrationViewer: FC = () => {
  const navigate = useNavigate();
  const { activeBranchId } = useUserPrint();
  const { contentWidth } = useContentWidth();
  const [searchParams] = useSearchParams();

  const migrationId = searchParams.get('id');

  const {
    data,
    isFetching: loader,
    isError,
    error,
  } = useGetMigrationYClientsQuery(
    {
      ActiveBranchId: activeBranchId!,
      legalEntityId: Number(migrationId),
    },
    { skip: !migrationId || !activeBranchId }
  );

  useErrorHandler([{ flag: isError, error }]);

  const gridSettings = useMemo(() => {
    return contentWidth > 600 ? 12 : 24;
  }, [contentWidth]);

  if (loader) {
    return <Skeleton active style={{ maxWidth: '600px' }} />;
  }

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ width: contentWidth > MOBILE ? '600px' : '100%' }}
    >
      <Row>
        <Col span={gridSettings}>
          <Text strong data-testid="login-title">
            Логин
          </Text>
        </Col>
        <Col span={gridSettings} data-testid="login-value">
          {data?.Login || '-'}
        </Col>
      </Row>
      <Row style={{ maxWidth: '600px' }}>
        <Col span={gridSettings}>
          <Text strong data-testid="legal-entity-title">
            Юридическое лицо
          </Text>
        </Col>
        <Col span={gridSettings} data-testid="legal-entity">
          {data?.LegalEntity || '-'}
        </Col>
      </Row>
      <Row style={{ maxWidth: '600px' }}>
        <Col span={gridSettings}>
          <Text strong data-testid="migration-status-title">
            Статус
          </Text>
        </Col>
        <Col span={gridSettings}>
          {data?.Status ? <StatusTag status={data?.Status} /> : '-'}
        </Col>
      </Row>
      {data?.TimeEnded && (
        <Row style={{ maxWidth: '600px' }}>
          <Col span={gridSettings}>
            <Text strong data-testid="migration-end-time-title">
              Время завершения миграции
            </Text>
          </Col>
          <Col span={gridSettings} data-testid="migration-end-time">
            {handleTimestamp(data?.TimeEnded)}
          </Col>
        </Row>
      )}
      <Button
        icon={<LeftOutlined />}
        type="primary"
        block={contentWidth > MOBILE ? false : true}
        style={{ marginTop: '8px', minWidth: '180px' }}
        onClick={() => navigate(DATA_MIGRATION_PATH)}
        data-testid="back-button"
      >
        Назад
      </Button>
    </Space>
  );
};
